(function () {
  var MODAL_ID = 'cf-modal', DATA_ID = 'cf-data-source', BTN_ID = 'cf-btn', WIDE_THRESHOLD = 4;

  var modal = document.getElementById(MODAL_ID);
  if (!modal) return;
  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  var _headers = [], _rows = [], _colCount = 0, _mode = 'card', _selectedVariant = '';

  var FIELD_WORDS = ['model','chassis','description','body','style','type','year','variant','notes','name','code','info','details','size','finish','colour','color'];

  function looksLikeChassisCode(str) {
    if (!str) return false;
    var s = str.trim().toLowerCase();
    if (FIELD_WORDS.indexOf(s) !== -1) return false;
    if (s.split(/\s+/).length > 2) return false;
    return /^[a-z]{0,3}\d{2,4}[a-z]?$/i.test(s.replace(/\s/g, '')) && s.length <= 8;
  }

  function detectOrientation(headers) {
    if (headers.length <= WIDE_THRESHOLD) return 'card';
    var cc = headers.filter(function (h) { return looksLikeChassisCode(h); }).length;
    if (cc / headers.length >= 0.5) return 'wide-chassis';
    return 'wide-label';
  }

  function normalise(str) {
    return String(str || '').toLowerCase().replace(/[\s\-_\/\.]+/g, '');
  }

  function rowMatches(r, query) {
    if (!query) return true;
    var raw = query.toLowerCase(), nq = normalise(query);
    return r.some(function (v) {
      return v.toLowerCase().indexOf(raw) !== -1 || normalise(v).indexOf(nq) !== -1;
    });
  }

  function detectVariant() {
    var sel = document.querySelector(
      '[name="options[Chassis]"] option:checked,' +
      '[name="options[chassis]"] option:checked,' +
      '[name="options[Size]"] option:checked,' +
      '[name="options[size]"] option:checked,' +
      '.product-form__input--dropdown option:checked'
    );
    if (sel && sel.textContent.trim() && sel.value !== '') {
      _selectedVariant = sel.textContent.trim(); return;
    }
    var btn = document.querySelector(
      '.product-form__input input:checked + label,' +
      '[data-option-index="0"] input:checked + label,' +
      '.variant-button.active,' +
      '.variant-button[aria-checked="true"]'
    );
    if (btn) { _selectedVariant = btn.textContent.trim(); return; }
    _selectedVariant = '';
  }

  function rowMatchesVariant(r) {
    if (!_selectedVariant) return false;
    var v = _selectedVariant.toLowerCase(), nv = normalise(_selectedVariant);
    return r.some(function (c) {
      return c.toLowerCase().indexOf(v) !== -1 || normalise(c).indexOf(nv) !== -1;
    });
  }

  function variantColIndex() {
    if (!_selectedVariant) return -1;
    var v = _selectedVariant.toLowerCase(), nv = normalise(_selectedVariant);
    for (var i = 0; i < _headers.length; i++) {
      var h = _headers[i].toLowerCase();
      if (h === v || normalise(h) === nv) return i;
    }
    return -1;
  }

  /* Split "W168 / W169 / W176" into ["W168","W169","W176"] */
  function splitCodes(val) {
    return val.split(/[\/,]/).map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
  }

  /* Get chassis codes from a row that match the selected variant */
  function getMatchingChassis(r) {
    if (!_selectedVariant) return [];
    var v = _selectedVariant.toLowerCase(), nv = normalise(_selectedVariant);
    var found = [];
    r.forEach(function (cell) {
      splitCodes(cell).forEach(function (code) {
        if ((code.toLowerCase().indexOf(v) !== -1 || normalise(code).indexOf(nv) !== -1) && found.indexOf(code) === -1) {
          found.push(code);
        }
      });
    });
    return found;
  }

  /* Get ALL chassis codes from a row */
  function getAllChassis(r) {
    var found = [];
    r.forEach(function (cell) {
      splitCodes(cell).forEach(function (code) {
        if (looksLikeChassisCode(code) && found.indexOf(code) === -1) found.push(code);
      });
    });
    return found;
  }

  function updateBtnCount() {
    var pill = document.getElementById('cf-btn-count');
    if (!pill) return;
    if (_rows.length > 0) { pill.textContent = _rows.length + ' vehicles'; pill.classList.add('show'); }
    else pill.classList.remove('show');
  }

  /* ── Parse data ──
     KEY FIX for wide-chassis 36-vehicle bug:
     In wide-chassis mode the source table has vehicles as COLUMNS not rows.
     Each data row = one attribute (e.g. "Model", "Body Style").
     So _rows in wide-chassis are attribute rows, not vehicle rows.
     The vehicle count = number of columns minus 1 (first col is the label).
     We detect this and store the real count separately.
  ── */
  var _vehicleCount = 0;

  function parseData() {
    _headers = []; _rows = []; _vehicleCount = 0;
    var src = document.getElementById(DATA_ID);
    if (!src) return;

    var tableRows = src.querySelectorAll('.ks-table-row');
    var isFirst = true;

    tableRows.forEach(function (tr) {
      var cells = tr.querySelectorAll('.ks-table-cell');
      var values = Array.from(cells).map(function (td) { return td.textContent.trim(); });

      if (isFirst) {
        _headers = values;
        isFirst = false;
        return;
      }

      /* Dedup repeated values within same row */
      var seen = [], deduped = [];
      values.forEach(function (v) {
        var low = v.toLowerCase();
        if (low !== '' && seen.indexOf(low) !== -1) { deduped.push(''); }
        else { if (low !== '') seen.push(low); deduped.push(v); }
      });
      while (deduped.length > 0 && deduped[deduped.length - 1] === '') deduped.pop();
      if (deduped.some(function (v) { return v.length > 0; })) _rows.push(deduped);
    });

    _colCount = Math.max(
      _headers.length,
      _rows.reduce(function (m, r) { return Math.max(m, r.length); }, 0)
    );
    while (_headers.length < _colCount) _headers.push('');

    _mode = detectOrientation(_headers);

    /* Vehicle count:
       - card mode: each row = one vehicle
       - wide-chassis: each column (after first) = one vehicle, each row = one attribute
       - wide-label: each row = one vehicle
    */
    if (_mode === 'wide-chassis') {
      /* Columns 1+ are vehicles — use header count minus 1 (first header is row label) */
      _vehicleCount = Math.max(0, _headers.filter(function(h){ return h.trim() !== ''; }).length - 1);
      /* If no row-label col, count all headers */
      if (!looksLikeChassisCode(_headers[0]) && _headers[0].trim() !== '') {
        _vehicleCount = _headers.length - 1;
      } else {
        _vehicleCount = _headers.length;
      }
    } else {
      _vehicleCount = _rows.length;
    }

    /* Build card-mode column headers */
    var bar = document.getElementById('cf-col-header');
    var hint = document.getElementById('cf-scroll-hint');
    if (bar) {
      if (_mode === 'card') {
        bar.classList.remove('cf-hidden'); bar.innerHTML = '';
        bar.style.gridTemplateColumns = gridCols(_colCount);
        _headers.forEach(function (h) {
          var s = document.createElement('span'); s.className = 'cf-col-title'; s.textContent = h; bar.appendChild(s);
        });
      } else {
        bar.classList.add('cf-hidden');
      }
    }
    if (hint) hint.classList.toggle('show', _mode !== 'card');

    updateBtnCount();
  }

  function updateBtnCount() {
    var pill = document.getElementById('cf-btn-count');
    if (!pill) return;
    if (_vehicleCount > 0) { pill.textContent = _vehicleCount + ' vehicles'; pill.classList.add('show'); }
    else pill.classList.remove('show');
  }

  function gridCols(n) {
    if (n <= 1) return '1fr';
    if (n === 2) return '2fr 1.5fr';
    if (n === 3) return '2fr 1.5fr 1.2fr';
    return '1.8fr ' + Array(n - 1).fill('1fr').join(' ');
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function highlight(str, q) {
    if (!q || !str) return esc(str);
    var safe = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!new RegExp(safe, 'i').test(str)) return esc(str);
    return esc(str).replace(new RegExp('(' + safe + ')', 'gi'), '<mark class="cf-hl">$1</mark>');
  }

  function groupByLetter(arr) {
    var g = {};
    arr.forEach(function (r) {
      var l = ((r[0] || '?')[0] || '?').toUpperCase();
      if (!g[l]) g[l] = []; g[l].push(r);
    });
    return g;
  }

  /* ── RENDER ── */
  function render(q) {
    var cfBody = document.getElementById('cf-body');
    var cfCount = document.getElementById('cf-count');
    var noRes = document.getElementById('cf-no-results');
    if (!cfBody) return;

    var query = (q || '').trim();
    var filtered = query ? _rows.filter(function (r) { return rowMatches(r, query); }) : _rows;
    var shown = filtered.length;

    /* For wide-chassis, the count shown should reflect filtered columns not rows */
    var displayCount = (_mode === 'wide-chassis' && !query) ? _vehicleCount : shown;

    if (cfCount) {
      cfCount.innerHTML = query
        ? '<strong>' + shown + '</strong> result' + (shown !== 1 ? 's' : '') + ' for &ldquo;' + esc(query) + '&rdquo;'
        : '<strong>' + displayCount + '</strong> compatible vehicles';
    }

    Array.from(cfBody.children).forEach(function (c) { if (c.id !== 'cf-no-results') c.remove(); });

    if (shown === 0) { noRes.classList.add('show'); return; }
    noRes.classList.remove('show');

    if (_mode === 'card') renderCards(filtered, query, cfBody, noRes);
    else renderWideTable(filtered, query, cfBody, noRes);
  }

  /* ── Wide table ── */
  function renderWideTable(filtered, query, cfBody, noRes) {
    var isSticky = (_mode === 'wide-label');
    var matchColIdx = variantColIndex();

    var wrap = document.createElement('div'); wrap.id = 'cf-table-wrap';
    var table = document.createElement('table'); table.id = 'cf-wide-table';
    table.setAttribute('data-sticky', isSticky ? 'true' : 'false');

    /* thead */
    var thead = document.createElement('thead'), htr = document.createElement('tr');
    _headers.forEach(function (h, i) {
      var th = document.createElement('th');
      th.innerHTML = highlight(h, query);
      if (i === matchColIdx) th.classList.add('cf-col-match');
      htr.appendChild(th);
    });
    thead.appendChild(htr); table.appendChild(thead);

    /* tbody */
    var tbody = document.createElement('tbody');
    filtered.forEach(function (r) {
      var tr = document.createElement('tr');
      for (var i = 0; i < _colCount; i++) {
        var val = r[i] || '', td = document.createElement('td');
        var isMatchCol = (i === matchColIdx);
        if (!isSticky) {
          if (val === '') { td.className = 'cf-td-empty'; td.textContent = '—'; }
          else { if (isMatchCol) td.classList.add('cf-col-match'); td.innerHTML = highlight(val, query); }
        } else {
          if (i === 0) { td.innerHTML = highlight(val, query); }
          else if (val === '') { td.className = 'cf-td-empty'; td.textContent = '—'; }
          else { td.className = 'cf-td-val' + (isMatchCol ? ' cf-col-match' : ''); td.innerHTML = highlight(val, query); }
        }
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    });

    table.appendChild(tbody); wrap.appendChild(table); cfBody.insertBefore(wrap, noRes);

    /* Auto-scroll to matched column */
    if (matchColIdx > 0) {
      setTimeout(function () {
        var matchTh = table.querySelector('thead th.cf-col-match');
        if (matchTh && wrap) wrap.scrollLeft = matchTh.offsetLeft - (wrap.offsetWidth / 2) + (matchTh.offsetWidth / 2);
      }, 200);
    }
  }

  /* ── Card grid ── */
  function renderCards(filtered, query, cfBody, noRes) {
    var frag = document.createDocumentFragment();
    var exactRows = [], partialRows = [], otherRows = [];

    if (query) {
      filtered.forEach(function (r) { frag.appendChild(makeCard(r, query, false, false)); });
    } else {
      /* Sort into buckets */
      filtered.forEach(function (r) {
        if (rowMatchesVariant(r)) {
          exactRows.push(r);
        } else if (_selectedVariant && getAllChassis(r).length > 0) {
          partialRows.push(r);
        } else {
          otherRows.push(r);
        }
      });

      /* 1. Exact matches — green "✓ This fits" + "Select W177" pill */
      if (exactRows.length > 0) {
        var fitLabel = document.createElement('div');
        fitLabel.className = 'cf-group-label';
        fitLabel.textContent = '✓  Fits Your Selection';
        fitLabel.style.color = 'var(--cf-green)';
        frag.appendChild(fitLabel);
        exactRows.forEach(function (r) { frag.appendChild(makeCard(r, '', true, false)); });
      }

      /* 2. All other vehicles grouped by letter (partials mixed in, shown with amber "Need:" pills) */
      var rest = _selectedVariant ? otherRows.concat(partialRows) : filtered;
      var groups = groupByLetter(rest);
      Object.keys(groups).sort().forEach(function (letter) {
        var label = document.createElement('div'); label.className = 'cf-group-label'; label.textContent = letter;
        frag.appendChild(label);
        groups[letter].forEach(function (r) {
          var isPartial = _selectedVariant && partialRows.indexOf(r) !== -1;
          frag.appendChild(makeCard(r, '', false, isPartial));
        });
      });
    }

    cfBody.insertBefore(frag, noRes);

    if (exactRows.length > 0 && !query) {
      setTimeout(function () {
        var first = cfBody.querySelector('.cf-row-match');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 250);
    }
  }

  function makeCard(r, q, isExact, isPartial) {
    var div = document.createElement('div');
    div.className = 'cf-row' + (isExact ? ' cf-row-match' : isPartial ? ' cf-row-partial' : '');
    div.setAttribute('role', 'listitem');
    div.style.gridTemplateColumns = gridCols(_colCount);

    var matchingCodes  = isExact   ? getMatchingChassis(r) : [];
    var availableCodes = isPartial ? getAllChassis(r)       : [];

    var html = '';
    for (var i = 0; i < _colCount; i++) {
      var val  = r[i] || '';
      var hdr  = _headers[i] || '';
      var vCls = i === 0 ? 'cf-val-col0' : i === 1 ? 'cf-val-col1' : 'cf-val-coln';

      html += '<div class="cf-cell">';
      html += '<span class="cf-cell-label">' + esc(hdr) + '</span>';
      html += '<span class="cf-cell-value ' + vCls + '">' + highlight(val, q) + '</span>';

      /* Exact match: col 0 gets fits badge, col 1 (chassis) gets "Select X" pill */
      if (isExact && i === 0) {
        html += '<span class="cf-match-badge">✓ This fits</span>';
      }
      if (isExact && i === 1 && matchingCodes.length > 0) {
        matchingCodes.forEach(function (code) {
          html += '<span class="cf-select-pill">' + esc(code) + '</span>';
        });
      }

      /* Partial match: col 1 shows which chassis codes are needed */
      if (isPartial && i === 1 && availableCodes.length > 0) {
        html += '<span class="cf-need-label">Need:</span>';
        availableCodes.forEach(function (code) {
          html += '<span class="cf-need-pill">' + esc(code) + '</span>';
        });
      }

      html += '</div>';
    }

    div.innerHTML = html;
    return div;
  }

  /* ── Open / Close ── */
  function openModal() {
    var cfSheet = document.getElementById('cf-sheet'); if (!cfSheet) return;
    detectVariant();

    var banner = document.getElementById('cf-variant-banner');
    var varVal = document.getElementById('cf-variant-value');
    if (banner && varVal) {
      if (_selectedVariant) { varVal.textContent = _selectedVariant; banner.classList.add('show'); }
      else banner.classList.remove('show');
    }

    var search = document.getElementById('cf-search');
    var clearBtn = document.getElementById('cf-clear-btn');
    if (search) search.value = '';
    if (clearBtn) clearBtn.classList.remove('show');

    render('');

    modal.removeAttribute('aria-hidden');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    var btn = document.getElementById(BTN_ID);
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeModal() {
    var search = document.getElementById('cf-search');
    var clearBtn = document.getElementById('cf-clear-btn');
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (search) search.value = '';
    if (clearBtn) clearBtn.classList.remove('show');
    var btn = document.getElementById(BTN_ID);
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  /* ── Events ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#' + BTN_ID))  { openModal();  return; }
    if (e.target.closest('#cf-close'))   { closeModal(); return; }
    if (e.target === modal)              { closeModal(); return; }
    if (e.target.id === 'cf-clear-btn' || e.target.closest('#cf-clear-btn')) {
      var s = document.getElementById('cf-search'), cb = document.getElementById('cf-clear-btn');
      if (s) { s.value = ''; s.focus(); }
      if (cb) cb.classList.remove('show');
      render('');
      var b = document.getElementById('cf-body'); if (b) b.scrollTop = 0;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
  });

  document.addEventListener('input', function (e) {
    if (e.target.id !== 'cf-search') return;
    var q = e.target.value, cb = document.getElementById('cf-clear-btn');
    if (cb) cb.classList.toggle('show', q.length > 0);
    render(q);
    var b = document.getElementById('cf-body'); if (b) b.scrollTop = 0;
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[name^="options"]') || e.target.matches('select[name="id"]')) {
      detectVariant();
      if (modal.classList.contains('open')) {
        render((document.getElementById('cf-search') || {}).value || '');
      }
    }
  });

  var _swipeY = 0, sheet = document.getElementById('cf-sheet');
  if (sheet) {
    sheet.addEventListener('touchstart', function (e) { _swipeY = e.touches[0].clientY; }, { passive: true });
    sheet.addEventListener('touchend', function (e) {
      var dy = e.changedTouches[0].clientY - _swipeY;
      var b = document.getElementById('cf-body');
      if (dy > 80 && b && b.scrollTop === 0) closeModal();
    }, { passive: true });
  }

  detectVariant();
  parseData();
})();